import { User } from '@bonusly/who-am-i';

import { Reaction } from './lib/reaction';
import { ReactionType } from './types';

export const buildReaction = (type: ReactionType, user: User) => ({
	_id: Math.random().toString(),
	emoji: Reaction.fromType(type).unicode,
	user_id: user.id,
	user_name: user.display_name,
});
